import { root } from './statistics';

export const statistics = {
  ...root,
};
